module.exports = __webpack_public_path__ + "static/media/menu-burger.a394ddd7.svg";